import React from 'react';
import { PlayIcon } from 'lucide-react';
import { Container, Section } from '../ui/Section';
import { videoPosterPhoto } from '../../data/photos';
type WelcomeVideoProps = {
  /** Once a real montage file exists, pass its hosted MP4/WebM URL here. */
  videoSrc?: string;
};
export function WelcomeVideo({
  videoSrc
}: WelcomeVideoProps) {
  return <Section className="bg-[#fffdf6] py-16 sm:py-20" labelledBy="video-heading" data-id="element-234" data-mp="3h2hcn51ql4kd">
      <Container className="max-w-4xl" data-id="element-235" data-mp="332y265lgdh4w">
        <h2 id="video-heading" className="font-serif text-3xl font-semibold leading-tight text-brand-navy sm:text-4xl" data-id="element-236" data-mp="383m2xizhhccb">
          See what BCM is like
        </h2>
        <p className="mt-4 font-sans text-[17px] leading-relaxed text-ink" data-id="element-237" data-mp="2u67as6huiqgn">
          A new welcome video featuring BCM students, worship, outreach, and community is being
          created for the fall semester.
        </p>

        <div className="mt-8 overflow-hidden rounded-[20px] border-2 border-brand-navy bg-brand-blue" data-id="element-238" data-mp="wel589jh070q">
          {videoSrc ? <video controls preload="metadata" className="aspect-video w-full bg-black" aria-label="UCF BCM welcome video" data-id="element-239" data-mp="238i09ey9w7ce">
              <source src={videoSrc} data-id="element-240" data-mp="2cykutjl1ltcu" />
              Your browser does not support embedded video.
            </video> : <div className="relative" data-id="element-241" data-mp="282m8e1j9ylf2">
              {videoPosterPhoto.src ? <img src={videoPosterPhoto.src} alt={videoPosterPhoto.alt} className="aspect-video w-full object-cover" data-id="element-242" data-mp="1kbgs5l9f9r48" /> : <div className="flex aspect-video w-full items-center justify-center px-6 text-center" data-id="element-243" data-mp="1u71q98bde78p">
                  <p className="font-meta text-[12px] uppercase tracking-[0.16em] text-brand-navy" data-id="element-244" data-mp="1pc4kqbdaug0k">
                    {videoPosterPhoto.subject} · {videoPosterPhoto.album} · real BCM photo
                  </p>
                </div>}
              <div className="absolute inset-0 flex flex-col items-center justify-center gap-4 bg-brand-navy/55" data-id="element-245" data-mp="37t6gq4fpswy1">
                <span aria-hidden="true" className="flex h-16 w-16 items-center justify-center rounded-full border-2 border-white/70 bg-white/25" data-id="element-246" data-mp="3cq6n6ggh81po">
                  <PlayIcon className="h-7 w-7 text-white" data-id="element-247" data-mp="3mocq91e0rdw4" />
                </span>
                <p className="rounded-full bg-brand-tan px-4 py-2 font-meta text-[13px] font-semibold text-brand-navy" data-id="element-248" data-mp="2p2oumipe0zln">
                  New welcome video coming soon.
                </p>
              </div>
            </div>}
        </div>
      </Container>
    </Section>;
}